module.exports = __webpack_public_path__ + "img/sainofei.adea6a03.png";